function addItemToCart(event) {
  const button = event.target;

  if (!button.classList.contains('js-add-psbo')) {
    return;
  }

  let variantId = button.dataset.psboId;
  const parentVariantId = button.dataset.psboParent;
  const parentLineKey = button.dataset.psboParentKey;
  const discountValue = button.dataset.psboValue;
  const discountPercent = button.dataset.psboPercent;
  const quantity = 1;

  if (variantId == '') {
    variantId = document.querySelector('#product_' + parentVariantId).value;
  }

  document.querySelector('#cart-items').classList.add('pointer-events-none');

  // Shopify's native nested cart lines: parent_line_key attaches this line to the
  // parent that is already in the cart, so the platform keeps them together in the
  // cart, checkout, order and emails, and removes the child with its parent.
  // The legacy _psbo_new property is kept because the discount/upsell logic reads it.
  const item = {
    quantity,
    id: variantId,
    properties: {
      '_psbo_new': parentVariantId,
      '_discountValue': discountValue,
      '_discountPercent': discountPercent
    }
  };

  if (parentLineKey) item.parent_line_key = parentLineKey;

  const addItem = (payload) => fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: [payload] })
  }).then(async (response) => ({ ok: response.ok, data: await response.json() }));

  addItem(item)
    .then((result) => {
      // Shopify can't nest an add-on under a bundle product or one of its components
      // ("Bundle products and add-ons can't be mixed") and rejects the whole request.
      // Retry as a plain line rather than losing the add to cart - the _psbo_new
      // property still groups it under the parent in the cart.
      if (!result.ok && item.parent_line_key) {
        const flat = { ...item };
        delete flat.parent_line_key;
        return addItem(flat);
      }

      return result;
    })
    .then((result) => {
      if (!result.ok) {
        throw new Error(result.data.description || result.data.message || 'cart error');
      }

      if (document.querySelector('.cc-main-cart')) {
        location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
      }
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);

      // Without this the cart stays greyed out and unclickable after a failed add.
      const cartItems = document.querySelector('#cart-items');
      if (cartItems) cartItems.classList.remove('pointer-events-none');
    });
}

document.addEventListener('click', addItemToCart);
